import {Component} from '@angular/core';

@Component({
    selector: 'app-contact-details',
    templateUrl: './contact-details.component.html',
    styleUrl: './contact-details.component.scss'
})
export class ContactDetailsComponent {

}
